export default __webpack_public_path__ + "9fe61069d4dbd3fcdd6055e4f2120c09.webp";